module.exports = __webpack_public_path__ + "static/media/logo121.94aae711.png";